/**
 * Product archive / collection paginator: "View more" load more and per-page count select.
 * Requires: #product-results, #load-more-products, #product-count-select, #shown-count, window.customPagination
 */
(function () {
  function getProductIds(container) {
    var ids = [];
    if (!container) return ids;
    var products = container.querySelectorAll('.product');
    for (var i = 0; i < products.length; i++) {
      var cls = products[i].className.match(/\bproduct-id-(\d+)\b/);
      if (cls) ids.push(cls[1]);
    }
    return ids;
  }

  function getPerPage(select) {
    if (!select) return 20;
    var val = parseInt(select.value, 10);
    return (val >= 1 && val <= 40) ? val : 20;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var wrap = document.getElementById('custom-paginator-wrap');
    var productsWrap = document.getElementById('product-results');
    var loadMoreBtn = document.getElementById('load-more-products');
    var countSelect = document.getElementById('product-count-select');
    var shownEl = document.getElementById('shown-count');
    var loader = document.getElementById('ajax-loading');

    if (!wrap || !productsWrap || !loadMoreBtn || !countSelect) return;
    if (typeof window.customPagination === 'undefined' || !window.customPagination.ajax_url) return;

    var config = window.customPagination;
    var total = Math.max(0, parseInt(config.total_posts, 10) || 0);
    var loadedIds = {};
    var loading = false;

    // Initial set of IDs from DOM
    getProductIds(productsWrap).forEach(function (id) {
      loadedIds[id] = true;
    });
    var loadedCount = Object.keys(loadedIds).length;

    function updateUI() {
      var remaining = Math.max(0, total - loadedCount);

      // Always show total products for current filter context,
      // not just how many are currently visible.
      if (shownEl) shownEl.textContent = total;

      if (remaining <= 0) {
        loadMoreBtn.disabled = true;
        loadMoreBtn.classList.add('disabled');
        loadMoreBtn.textContent = 'No more products';
      } else {
        loadMoreBtn.disabled = false;
        loadMoreBtn.classList.remove('disabled');
        loadMoreBtn.textContent = 'VIEW MORE →';
      }
    }

    countSelect.addEventListener('change', function () {
      updateUI();
    });

    loadMoreBtn.addEventListener('click', function () {
      if (loading || loadMoreBtn.disabled) return;

      var perPage = getPerPage(countSelect);
      var remaining = Math.max(0, total - loadedCount);
      var toRequest = Math.min(perPage, remaining);
      if (toRequest <= 0) {
        updateUI();
        return;
      }

      var excludeRaw = Object.keys(loadedIds).join(',');
      var nonce = (window.customPagination && window.customPagination.load_more_nonce) ? window.customPagination.load_more_nonce : '';
      var body = 'action=load_more_products&per_page=' + toRequest + '&exclude_ids=' + encodeURIComponent(excludeRaw) + '&nonce=' + encodeURIComponent(nonce);

      // Send current filter state so load more respects filters (marble, color, etc.)
      var filtersForm = document.getElementById('filters-form');
      if (filtersForm) {
        filtersForm.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
          if (cb.name && cb.value) body += '&' + encodeURIComponent(cb.name) + '=' + encodeURIComponent(cb.value);
        });
        var searchInput = document.getElementById('product-search-input');
        if (searchInput && searchInput.value.trim()) {
          body += '&search=' + encodeURIComponent(searchInput.value.trim());
        }
      } else {
        // No form (e.g. collection taxonomy page): use page context
        var categorySlug = (config.category_slug || '').trim();
        var collectionSlug = (config.collection_slug || '').trim();
        if (categorySlug) body += '&category[]=' + encodeURIComponent(categorySlug);
        if (collectionSlug) body += '&collection[]=' + encodeURIComponent(collectionSlug);
      }

      loading = true;
      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = 'Loading...';
      if (loader) loader.style.display = 'block';

      fetch(config.ajax_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var items = temp.querySelectorAll('li.product');
          var appended = 0;
          for (var i = 0; i < items.length && appended < toRequest; i++) {
            var cls = items[i].className.match(/\bproduct-id-(\d+)\b/);
            if (cls && !loadedIds[cls[1]]) {
              loadedIds[cls[1]] = true;
              productsWrap.appendChild(items[i]);
              appended++;
            }
          }
          loadedCount = Object.keys(loadedIds).length;
          updateUI();
        })
        .catch(function () {
          loadMoreBtn.disabled = false;
          loadMoreBtn.classList.remove('disabled');
          updateUI();
        })
        .then(function () {
          loading = false;
          if (loader) loader.style.display = 'none';
        });
    });

    // Re-sync when filters change (filter_products response updates DOM and total)
    document.addEventListener('productFiltersUpdated', function () {
      total = Math.max(0, parseInt(window.customPagination && window.customPagination.total_posts, 10) || 0);
      loadedIds = {};
      getProductIds(productsWrap).forEach(function (id) {
        loadedIds[id] = true;
      });
      loadedCount = Object.keys(loadedIds).length;
      updateUI();
    });

    updateUI();
  });
})();
